var _rect, _g, _path, _path2, _path3, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame1171277064(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 39,
    viewBox: "0 0 37 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.300293,
    width: 36.1006,
    height: 38.1165,
    rx: 12,
    fill: "#E0E0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3375_19297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4762 17.9646L11.3957 16.869L14.2963 27.8521L11.278 28.1166L10.4762 17.9646Z",
    fill: "url(#paint0_linear_3375_19297)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4762 17.9646L11.3957 16.869L14.2963 27.8521L11.278 28.1166L10.4762 17.9646Z",
    fill: "url(#paint1_linear_3375_19297)",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4123 16.8639L14.3777 16.604L15.3553 27.7591L12.3899 28.019L11.4123 16.8639Z",
    fill: "url(#paint2_linear_3375_19297)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2727 10.8789L23.5971 10.051L24.6319 27.9878L21.6044 27.8681L22.2727 10.8789Z",
    fill: "url(#paint3_linear_3375_19297)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2727 10.8789L23.5971 10.051L24.6319 27.9878L21.6044 27.8681L22.2727 10.8789Z",
    fill: "url(#paint4_linear_3375_19297)",
    fillOpacity: 0.29
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4256 10.0658L26.4 10.1834L25.6943 28.0298L22.7199 27.9121L23.4256 10.0658Z",
    fill: "url(#paint5_linear_3375_19297)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3375_19297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9931 14.3309L17.0644 13.5274L19.4386 27.9465L16.4103 28.0438L15.9931 14.3309Z",
    fill: "url(#paint6_linear_3375_19297)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9931 14.3309L17.0644 13.5274L19.4386 27.9465L16.4103 28.0438L15.9931 14.3309Z",
    fill: "url(#paint7_linear_3375_19297)",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.059 13.4584L20.0342 13.3628L20.5014 27.9126L17.5262 28.0082L17.059 13.4584Z",
    fill: "url(#paint8_linear_3375_19297)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3375_19297",
    x: 10.2906,
    y: 16.1253,
    width: 7.00899,
    height: 13.6424,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.879292,
    dy: 0.586195
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.53246
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3375_19297"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3375_19297",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3375_19297",
    x: 15.5045,
    y: 12.2881,
    width: 7.43927,
    height: 17.6119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.976991,
    dy: 0.390796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.732743
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3375_19297"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3375_19297",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3375_19297",
    x1: 10.8016,
    y1: 13.3764,
    x2: 19.2442,
    y2: 20.8364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132927,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392361,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3375_19297",
    x1: 11.8051,
    y1: 16.7793,
    x2: 12.7871,
    y2: 27.9843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3375_19297",
    x1: 11.9051,
    y1: 13.3455,
    x2: 20.3056,
    y2: 20.6701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253989,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634371,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3375_19297",
    x1: 23.3429,
    y1: 4.39604,
    x2: 34.4467,
    y2: 12.3697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132927,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392361,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3375_19297",
    x1: 23.8264,
    y1: 9.97445,
    x2: 23.1164,
    y2: 27.9279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3375_19297",
    x1: 24.4412,
    y1: 4.57979,
    x2: 35.426,
    y2: 12.3702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253989,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634371,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3375_19297",
    x1: 16.6105,
    y1: 8.96961,
    x2: 26.7071,
    y2: 16.6577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132927,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392361,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3375_19297",
    x1: 17.4573,
    y1: 13.4454,
    x2: 17.9244,
    y2: 27.9952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3375_19297",
    x1: 17.7122,
    y1: 8.93444,
    x2: 27.7664,
    y2: 16.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253989,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634371,
    stopColor: "#1C1C1C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1171277064);
export default __webpack_public_path__ + "static/media/Frame 1171277064.c557a840c093803c74f790d2574457a6.svg";
export { ForwardRef as ReactComponent };